import React, { useEffect, useState } from "react";
import { Typography } from "antd";
const { Text } = Typography;

const ChildAge = (props) => {
  const { record, field } = props;
  const [age, setAge] = useState(null);

  useEffect(() => {
    var today = new Date();
    var birthDate = new Date(record[field]);
    var result = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      result--;
    }
    setAge(result);
  }, []);

  return <Text style={{ opacity: age >= 18 ? 0.5 : 1 }}>{age}</Text>;
};

export default ChildAge;
